import { Helmet } from "react-helmet-async";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import WhatWeDo from "./components/WhatWeDo";
import RegulatedSectors from "./components/RegulatedSectors";
import FeaturedOpportunities from "./components/FeaturedOpportunities";
import WhyChooseAIP from "./components/WhyChooseAIP";
import HomeCTA from "./components/HomeCTA";

export default function Home() {
  return (
    <main>
      <Helmet>
        <title>Africa Investment Portal | Company Registration & Investment in East Africa</title>
        <meta name="description" content="AIP is East Africa's trusted investment and business facilitation portal. Expert support for company registration, FDI, compliance, and tenders across Rwanda, Kenya, Uganda, Tanzania and more." />
        <meta name="keywords" content="Africa investment portal, company registration East Africa, FDI East Africa, invest in Rwanda, invest in Kenya, invest in Uganda, invest in Tanzania, business registration Africa, foreign direct investment, investment facilitation" />
        <link rel="canonical" href="https://africainvestmentportal.com" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Africa Investment Portal | Your Gateway to East Africa" />
        <meta property="og:description" content="From company registration to market access — trusted investment and business facilitation across East Africa." />
        <meta property="og:url" content="https://africainvestmentportal.com" />
        <meta property="og:image" content="https://africainvestmentportal.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Africa Investment Portal | Your Gateway to East Africa" />
        <meta name="twitter:description" content="From company registration to market access — trusted investment and business facilitation across East Africa." />
        <meta name="twitter:image" content="https://africainvestmentportal.com/og-image.jpg" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Africa Investment Portal",
          "url": "https://africainvestmentportal.com",
          "": "https://africainvestmentportal.com/logo.png",
          "description": "East Africa's trusted investment and business facilitation portal covering Rwanda, Kenya, Uganda, Tanzania, Ethiopia, Burundi, and DRC.",
          "areaServed": ["Rwanda", "Kenya", "Uganda", "Tanzania", "Ethiopia", "Burundi", "Democratic Republic of the Congo"],
          "sameAs": []
        })}</script>
      </Helmet>
      <Navbar />
      <HeroSection />
      <WhatWeDo />
      <RegulatedSectors />
      <FeaturedOpportunities />
      <WhyChooseAIP />
      <HomeCTA />
      <Footer />
    </main>
  );
}
